import '/assets/styles/pages/checkout-auth.scss';

// Partials
import Btn from '/views/partials/btn';

// Context
import { useTranslation } from '/utilities/i18n';

// Context
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';

export const CheckoutAuth = () => {
	const { openModal } = useModals();
	const { t } = useTranslation();

	return (
		<div className="checkout-auth">
			<div className="auth-wrap wrapper">
				<div className="auth-container">
					<h1 className="auth-title">{t('Bilet satın almak için üye girişi yapmalısınız.')}</h1>
					<Btn
						onClick={() => {
							openModal('auth');
						}}
						className="primary"
					>
						{t('Giriş Yap')}
					</Btn>
				</div>
			</div>
		</div>
	);
};

export default CheckoutAuth;
